import type {z} from "zod";

import {UpdateSupplierFunctionBody} from "@project/sdk/engineering/zod";

export const updateSupplierFunctionFormSchema = UpdateSupplierFunctionBody;
export type UpdateSupplierFunctionFormPayload = z.output<typeof updateSupplierFunctionFormSchema>;

export const draftUpdateSupplierFunctionFormSchema = updateSupplierFunctionFormSchema.partial();
export type DraftUpdateSupplierFunctionFormPayload = z.output<
  typeof draftUpdateSupplierFunctionFormSchema
>;
